export default __webpack_public_path__ + "static/media/Interieur.24e9b0da.jpg";